import {
  Button,
  Dialog,
  Flex,
  Text,
  TextInput,
  TextInputProps,
  createForm,
} from '@applyboard/crystal-ui'
import { ComponentType } from 'react'

type OtpVerificationDialogProps = {
  open: boolean
  loading: boolean
  currentEmail: string
  onOpenChange: (open: boolean) => void
  onSubmit: (oneTimePass: string) => void
}

const { Form: OldEmailOtpForm, Field: OldEmailOtpField } = createForm<{ oneTimePass: string }>()

export function OldEmailOtpDialog(props: OtpVerificationDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Heading>
        <Flex direction="column" gap={0}>
          <Text variant="labelS">STEP 2/3</Text>
          <Text variant="titleM">Verify your current email</Text>
        </Flex>
      </Dialog.Heading>
      <Dialog.Content>
        <Flex direction="column" gap={4}>
          <Text>
            Enter the one-time passcode sent to your <strong>current</strong> email address:{' '}
            <strong>{props.currentEmail}</strong>.
          </Text>
          <OldEmailOtpForm
            defaultValues={{ oneTimePass: '' }}
            onSubmit={data => props.onSubmit(data.oneTimePass)}
            id="old-email-otp-form"
          >
            <OldEmailOtpField
              as={TextInput as ComponentType<TextInputProps>}
              label="One-time passcode"
              name="oneTimePass"
              validate={otp => {
                if (!otp) {
                  return 'Please enter the passcode.'
                }
                return true
              }}
            />
          </OldEmailOtpForm>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <Button
          intent="primary"
          width="fill"
          type="submit"
          form="old-email-otp-form"
          loading={props.loading}
        >
          Verify
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}
